import PubSub from "underpub-js";
import Slick from "slick-carousel";

var HeroContentImageSlider = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

HeroContentImageSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$imageSlider = this.options.$el.find('.image-slider')
	this.$textSlider = this.options.$el.find('.text-slider');

	// initialize image slider
	this.$imageSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		asNavFor: self.$textSlider[0],
	});

	// initialize text slider
	this.$textSlider.slick({
		arrows: false,
		fade: true,
		speed: 200,
		asNavFor: self.$imageSlider[0],
		swipe: false,
	});

	// right side text
	this.positionRightSideText();

	PubSub.subscribe("resized", function(){
		self.positionRightSideText();
	});

	// next image button
	this.options.$el.find('.next-image').on('click', function() {

		//self.$imageSlider.slick('slickNext');
		self.$textSlider.slick('slickNext');

		self.startAutoplay();

	});

	// kick off autoplay
	this.startAutoplay();

};

HeroContentImageSlider.prototype.startAutoplay = function() {

	var self = this;

	this.autoplayInterval;

	window.clearInterval(self.autoplayInterval);

	this.autoplayInterval = window.setInterval(function() {
		console.log('here');
		self.$textSlider.slick('slickNext');
	}, 8000);

};

HeroContentImageSlider.prototype.positionRightSideText = function() {

	// top
	var $rightSideText = this.options.$el.find('.right-side-text');
	var $contentWrapper = this.options.$el;

	var rightSideTextHeight = $rightSideText.width(); // element is rotated via css so width is actually height
	var rightSideTextWidth = $rightSideText.height(); // element is rotated via css so height is actually width
	var contentWrapperHeight = $contentWrapper.outerHeight();
	var contentWrapperWidth = $contentWrapper.width();

	var newTop = (contentWrapperHeight / 2) - (rightSideTextWidth / 2);
	$rightSideText.css('top', newTop);

	// right
	// the first two numbers here get the transformed element back to aligned with the edge, third number is the offset from the edge
	var newRight = ((rightSideTextHeight / 2) * -1) + (rightSideTextWidth / 2) + (contentWrapperWidth * 0.035);
	$rightSideText.css('right', newRight);

};

export default HeroContentImageSlider;
